import React from 'react';
import { Redirect, Switch } from 'react-router-dom';
import { Versions } from '@services/types';
import { isAccessibleRoute, Navigation } from '@constants/Navigation';
import AdminUsers from '@layouts/admin/Users';
import AdminApiUsers from '@layouts/admin/ApiUsers';
import DeviceTypePage from '@layouts/admin/DeviceType';
import SuperGroups from '@layouts/admin/SuperGroups';
import GlobalSettings from '@layouts/admin/GlobalSettings';
import Firmwares from '@layouts/firmwares/Firmwares';
import Rules from '@layouts/firmwares/Rules';
import STBGroup from '@layouts/devices/STBGroup';
import Devices from '@layouts/devices/Devices';
import SideBarMenu from '@layouts/sidebar/SideBarMenu';
import api from '@services/api';
import DeviceUpdatePage from '@layouts/devices/Devices/DeviceUpdatePage';
import DeviceTypeSettings from '@layouts/admin/DeviceType/DeviceTypeSettings';
import BatchMove from '@layouts/devices/BatchMove';
import ProvisionedDevices from '@layouts/devices/ProvisionedDevices';
import ActionHistory from '@layouts/admin/ActionHistory';
import Certificates from '@layouts/admin/Certificates';
import Reports from '@layouts/reports';
import ProtectedRoute from '@layouts/ProtectedRoute';
import { AppContext } from '@layouts/AppRouter';
import Jobs from '@layouts/jobs';
import InfoJobPage from '@layouts/jobs/InfoJobPage';
import Dashboard from '@layouts/dashboard';
import IncorrectRequests from '@layouts/incorrectRequests';
import GroupMap from '@layouts/reports/GroupMap';
import Rescue from '@layouts/firmwares/Rescue';
import Tags from '@layouts/tags';
import { RightSquareFilled } from '@ant-design/icons';
import InfoFirmwareModal from '@layouts/firmwares/Firmwares/InfoFirmwareModal';
import DeployFirmwareModal from '@layouts/firmwares/Firmwares/DeployFirmwareModal';
import CreateFirmwareModal from '@layouts/firmwares/Firmwares/CreateFirmwareModal';
import InfoUserModal from '@layouts/admin/Users/InfoUserModal';
import CreateUserModal from '@layouts/admin/Users/CreateUserModal';
import InfoApiUserModal from '@layouts/admin/ApiUsers/InfoApiUserModal';
import CreateApiUserModal from '@layouts/admin/ApiUsers/CreateApiUserModal';
import InfoDeviceTypeModal from '@layouts/admin/DeviceType/InfoDeviceTypeModal';
import CreateDeviceTypeModal from '@layouts/admin/DeviceType/CreateDeviceTypeModal';
import EditRuleModal from '@layouts/firmwares/Rules/EditRuleModal';
import CreateRescueModal from '@layouts/firmwares/Rescue/CreateRescueModal';
import InfoRescueModal from '@layouts/firmwares/Rescue/InfoRescueModal';
import MyProfile from '@layouts/profile/MyProfile';
import RequestTrackingDashboard from '@layouts/tracking/RequestTrackingDashboard';
import DeviceTrackingPage from '@layouts/tracking/DeviceTrackingPage';

const Main = () => {
  const { user, hideSideBar, setHideSideBar } = React.useContext(AppContext);
  const [version, setVersion] = React.useState<Versions>();

  React.useEffect(() => {
    api.version.versions().then(setVersion);
  }, []);

  return (
    <div>
      {!hideSideBar ? (
        <SideBarMenu />
      ) : (
        <div
          style={{
            position: 'fixed',
            color: '#1890ff',
            fontSize: '25px',
            cursor: 'pointer',
            top: '25px',
            left: '10px',
          }}
        >
          <RightSquareFilled
            onClick={() => {
              setHideSideBar(false);
            }}
          />
        </div>
      )}
      <div className={!hideSideBar ? 'container' : 'hideContainer'}>
        <Switch>
          <ProtectedRoute exact path={Navigation.Devices} component={Devices} />
          <ProtectedRoute exact path={Navigation.Dashboard} component={Dashboard} />
          <ProtectedRoute exact path={Navigation.UpdateDevice} component={DeviceUpdatePage} />
          <ProtectedRoute path={Navigation.STBGroup} component={STBGroup} />
          <ProtectedRoute exact path={Navigation.Firmwares} component={Firmwares} />
          <ProtectedRoute exact path={Navigation.FirmwaresInfo} component={InfoFirmwareModal} />
          <ProtectedRoute exact path={Navigation.DeployFirmware} component={DeployFirmwareModal} />
          <ProtectedRoute exact path={Navigation.CreateFirmware} component={CreateFirmwareModal} />
          <ProtectedRoute exact path={Navigation.Rules} component={Rules} />
          <ProtectedRoute exact path={Navigation.CreateRule} component={EditRuleModal} />
          <ProtectedRoute exact path={Navigation.UpdateRule} component={EditRuleModal} />
          <ProtectedRoute exact path={Navigation.Rescue} component={Rescue} />
          <ProtectedRoute exact path={Navigation.CreateRescue} component={CreateRescueModal} />
          <ProtectedRoute exact path={Navigation.UpdateRescue} component={CreateRescueModal} />
          <ProtectedRoute exact path={Navigation.RescueInfo} component={InfoRescueModal} />
          <ProtectedRoute exact path={Navigation.Rules.replace('/:id', '') as Navigation} component={Rules} />
          <ProtectedRoute exact path={Navigation.Administration} component={AdminUsers} />
          <ProtectedRoute exact path={Navigation.UserInfo} component={InfoUserModal} />
          <ProtectedRoute exact path={Navigation.CreateUser} component={CreateUserModal} />
          <ProtectedRoute exact path={Navigation.UpdateUser} component={CreateUserModal} />
          <ProtectedRoute exact path={Navigation.ApiUsers} component={AdminApiUsers} />
          <ProtectedRoute exact path={Navigation.ApiUserInfo} component={InfoApiUserModal} />
          <ProtectedRoute exact path={Navigation.CreateApiUser} component={CreateApiUserModal} />
          <ProtectedRoute exact path={Navigation.UpdateApiUser} component={CreateApiUserModal} />
          <ProtectedRoute exact path={Navigation.SuperGroup} component={SuperGroups} />
          <ProtectedRoute exact path={Navigation.DeviceType} component={DeviceTypePage} />
          <ProtectedRoute exact path={Navigation.DeviceTypeSettings} component={DeviceTypeSettings} />
          <ProtectedRoute exact path={Navigation.DeviceTypeInfo} component={InfoDeviceTypeModal} />
          <ProtectedRoute exact path={Navigation.UpdateDeviceType} component={CreateDeviceTypeModal} />
          <ProtectedRoute exact path={Navigation.CreateDeviceType} component={CreateDeviceTypeModal} />
          <ProtectedRoute exact path={Navigation.GlobalSettings} component={GlobalSettings} />
          <ProtectedRoute exact path={Navigation.BatchMove} component={BatchMove} />
          <ProtectedRoute exact path={Navigation.ProvisionedDevices} component={ProvisionedDevices} />
          <ProtectedRoute exact path={Navigation.ActionHistory} component={ActionHistory} />
          <ProtectedRoute exact path={Navigation.Certificates} component={Certificates} />
          <ProtectedRoute exact path={Navigation.ReportsById} component={Reports} />
          <ProtectedRoute exact path={Navigation.GroupMap} component={GroupMap} />
          <ProtectedRoute exact path={Navigation.Tags} component={Tags} />
          <ProtectedRoute exact path={Navigation.Jobs} component={Jobs} />
          <ProtectedRoute exact path={Navigation.JobInfo} component={InfoJobPage} />
          <ProtectedRoute exact path={Navigation.IncorrectRequests} component={IncorrectRequests} />
          <ProtectedRoute exact path={Navigation.RequestTracking} component={RequestTrackingDashboard} />
          <ProtectedRoute exact path={Navigation.DeviceTracking} component={DeviceTrackingPage} />
          <ProtectedRoute exact path={Navigation.MyProfile} component={MyProfile} />
          {isAccessibleRoute(user, Navigation.Devices) && <Redirect to={Navigation.Devices} />}
          {isAccessibleRoute(user, Navigation.Firmwares) && <Redirect to={Navigation.Firmwares} />}
        </Switch>
      </div>
      <div className="bottom_upgrade">
        <span>{version?.version}</span>
        <span>{version?.environmentFlavour}</span>
      </div>
    </div>
  );
};

export default React.memo(Main);
